import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 1.05rem;
  color: ${DEFAULT_COLORS.text.primary};
  margin: 10px 0;
`;

export const AutoSelectedNote = styled.span`
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.55);
  font-style: italic;
  margin-left: 8px;
`;

export const BillingQuestion = styled.div`
  font-weight: 500;
  font-size: 0.95rem;
  color: ${DEFAULT_COLORS.text.primary};
  margin-bottom: 16px;
`;

export const RadioGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: 1fr;
  }
`;

export const RadioCard = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  border: 1.5px solid
    ${({ $selected }) => ($selected ? DEFAULT_COLORS.primary : 'rgba(0, 0, 0, 0.12)')};
  border-radius: 8px;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? DEFAULT_COLORS.grey4 : '#fff')};
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${({ $selected }) =>
      $selected ? DEFAULT_COLORS.primary : 'rgba(0, 0, 0, 0.25)'};
  }
`;

export const RadioCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const RadioCardLabel = styled.span`
  font-weight: 500;
  font-size: 0.95rem;
  color: ${DEFAULT_COLORS.text.primary};
`;

export const RadioCardDescription = styled.span`
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.55);
`;

export const OverrideSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

/* Shared card & index badge used in both create and edit mode */
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

export const CardIcon = styled.span`
  color: ${DEFAULT_COLORS.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardIndex = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${DEFAULT_COLORS.text.primary};
  background: ${DEFAULT_COLORS.primaryLight};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardName = styled.span`
  font-weight: 500;
  font-size: 1rem;
  color: ${DEFAULT_COLORS.text.primary};
`;

export const CardAddress = styled.div`
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 10px;
  margin-left: 28px;
`;

export const CardRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: 12px;
  }
`;

export const CardShipSection = styled.div`
  flex: 0 0 40%;
  min-width: 0;
`;

export const CardBillSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CardBillLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 6px;
  letter-spacing: 0.5px;
`;

/* Edit mode: side-by-side ship/bill display */
export const EditAddressRow = styled.div`
  display: flex;
  gap: 32px;
  margin-left: 28px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const EditAddressBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const EditAddressLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 4px;
  letter-spacing: 0.5px;
`;

export const EditAddressValue = styled.div`
  font-size: 0.88rem;
  color: ${DEFAULT_COLORS.text.primary};
  line-height: 1.4;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0;
  margin-top: 10px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    > * {
      width: 100%;
    }
  }
`;
